<template>
  <div class="mt-20 text-center p-4 mx-auto w-1/2">
    <p>
      Benvenuto in Aste Corepla
    </p>
    <a
      class="bg-corepla-dark text-white font-bold rounded p-2 m-4 inline-block"
      href="#"
      @click.prevent="handleLogin"
    >Accedi al Portale</a>
  </div>
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
const { loginWithRedirect } = useAuth0();

const handleLogin = () => {
  loginWithRedirect({
    appState: {
      target: "/login",
    },
  });
};
</script>

